module.exports = __webpack_public_path__ + "static/img/1.318cf4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/download-new/1.png
// module id = +buF
// module chunks = 2